export default "__VITE_ASSET__XNDCtMk$__"